/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface ProductData
 */
export interface ProductData {
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    integrationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    productRemoteId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductData
     */
    amount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductData
     */
    purchasePrice?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof ProductData
     */
    purchaseCostUnknownCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductData
     */
    purchaseCostEstimatedCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductData
     */
    purchaseCostComplete?: boolean;
    /**
     * 
     * @type {ProductDataAbcGroupEnum}
     * @memberof ProductData
     */
    abcGroup?: ProductDataAbcGroupEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ProductData
     */
    abcShare?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductData
     */
    abcCumulativeShare?: number | null;
}


/**
 * @export
 */
export const ProductDataAbcGroupEnum = {
    A: 'A',
    B: 'B',
    C: 'C'
} as const;
export type ProductDataAbcGroupEnum = typeof ProductDataAbcGroupEnum[keyof typeof ProductDataAbcGroupEnum];


/**
 * Check if a given object implements the ProductData interface.
 */
export function instanceOfProductData(value: object): value is ProductData {
    return true;
}

export function ProductDataFromJSON(json: any): ProductData {
    return ProductDataFromJSONTyped(json, false);
}

export function ProductDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductData {
    if (json == null) {
        return json;
    }
    return {
        
        'productName': json['productName'] == null ? undefined : json['productName'],
        'integrationId': json['integrationId'] === undefined ? undefined : json['integrationId'] === null ? null : json['integrationId'],
        'productRemoteId': json['productRemoteId'] === undefined ? undefined : json['productRemoteId'] === null ? null : json['productRemoteId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'purchasePrice': json['purchasePrice'] == null ? undefined : MoneyOutputFromJSON(json['purchasePrice']),
        'purchaseCostUnknownCount': json['purchaseCostUnknownCount'] == null ? undefined : json['purchaseCostUnknownCount'],
        'purchaseCostEstimatedCount': json['purchaseCostEstimatedCount'] == null ? undefined : json['purchaseCostEstimatedCount'],
        'purchaseCostComplete': json['purchaseCostComplete'] == null ? undefined : json['purchaseCostComplete'],
        'abcGroup': json['abcGroup'] === undefined ? undefined : json['abcGroup'] === null ? null : json['abcGroup'],
        'abcShare': json['abcShare'] === undefined ? undefined : json['abcShare'] === null ? null : json['abcShare'],
        'abcCumulativeShare': json['abcCumulativeShare'] === undefined ? undefined : json['abcCumulativeShare'] === null ? null : json['abcCumulativeShare'],
    };
}

export function ProductDataToJSON(json: any): ProductData {
    return ProductDataToJSONTyped(json, false);
}

export function ProductDataToJSONTyped(value?: ProductData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productName': value['productName'],
        'integrationId': value['integrationId'],
        'productRemoteId': value['productRemoteId'],
        'amount': value['amount'],
        'turnover': MoneyOutputToJSON(value['turnover']),
        'purchasePrice': MoneyOutputToJSON(value['purchasePrice']),
        'purchaseCostUnknownCount': value['purchaseCostUnknownCount'],
        'purchaseCostEstimatedCount': value['purchaseCostEstimatedCount'],
        'purchaseCostComplete': value['purchaseCostComplete'],
        'abcGroup': value['abcGroup'],
        'abcShare': value['abcShare'],
        'abcCumulativeShare': value['abcCumulativeShare'],
    };
}

